import { Head, Link } from '@inertiajs/react'
import AdminLayout from '../../components/layout/AdminLayout'
import StatsCard from '../../components/dashboard/StatsCard'
import QuickActions from '../../components/dashboard/QuickActions'
import CreditsWidget from '../../components/dashboard/CreditsWidget'
import RecentLeadsList from '../../components/dashboard/RecentLeadsList'
import PendingMatchesList from '../../components/dashboard/PendingMatchesList'
import RecentTransactionsList from '../../components/dashboard/RecentTransactionsList'

export default function DashboardIndex({ stats, recentLeads, pendingMatches, recentTransactions, agency }) {
  return (
    <AdminLayout>
      <Head title="Dashboard" />

      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Dashboard</h1>
            <p className="text-gray-600 mt-1">Bienvenue, {agency.name}</p>
          </div>
          <QuickActions />
        </div>

        {/* Alerte crédits faibles */}
        {stats.credits.low_credits && (
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm text-yellow-700">
                  Crédits faibles : {stats.credits.balance} crédit{stats.credits.balance > 1 ? 's' : ''} restant{stats.credits.balance > 1 ? 's' : ''}
                  <Link href="/credits" className="font-medium underline ml-2 hover:text-yellow-800">
                    Recharger maintenant
                  </Link>
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <StatsCard
            title="Leads"
            value={stats.leads.total}
            subtitle={`${stats.leads.new} nouveaux`}
            trend={stats.leads.this_month}
            trendLabel="ce mois"
            icon="users"
            color="blue"
            href="/leads"
          />

          <StatsCard
            title="Propriétés"
            value={stats.properties.total}
            subtitle={`${stats.properties.available} disponibles`}
            icon="home"
            color="green"
            href="/properties"
          />

          <StatsCard
            title="Matches"
            value={stats.matches.pending}
            subtitle={`${stats.matches.accepted} acceptés`}
            trend={stats.matches.this_week}
            trendLabel="cette semaine"
            icon="link"
            color="purple"
            href="/matches"
          />

          <CreditsWidget credits={stats.credits} />
        </div>

        {/* Contenu principal - 2 colonnes */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Leads récents */}
          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-lg font-semibold text-gray-900">Leads récents</h2>
              <Link href="/leads" className="text-sm text-primary-600 hover:text-primary-700 font-medium">
                Voir tout →
              </Link>
            </div>
            <RecentLeadsList leads={recentLeads} />
          </div>

          {/* Matches en attente */}
          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-lg font-semibold text-gray-900">Matches en attente</h2>
              <Link href="/matches" className="text-sm text-primary-600 hover:text-primary-700 font-medium">
                Voir tout →
              </Link>
            </div>
            <PendingMatchesList matches={pendingMatches} />
          </div>
        </div>

        {/* Transactions récentes */}
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold text-gray-900">Transactions récentes</h2>
            <Link href="/transactions" className="text-sm text-primary-600 hover:text-primary-700 font-medium">
              Voir tout →
            </Link>
          </div>
          <RecentTransactionsList transactions={recentTransactions} compact />
        </div>
      </div>
    </AdminLayout>
  )
}
